var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaleBanned(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5635_11628)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 60,
    fill: "#9F9EA1",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8672 95.2734C71.5703 92.0469 71.6875 89.7969 71.6875 86.8516C73.1484 86.0859 75.7656 81.2031 76.2031 77.0781C77.3516 76.9844 79.1641 75.8672 79.6953 71.4453C79.9766 69.0703 78.8438 67.7344 78.1484 67.3125C80.0156 61.6953 83.8984 44.3125 70.9766 42.5156C69.6406 40.1797 66.2344 39 61.8125 39C44.1016 39.3281 41.9688 52.375 45.8516 67.3125C45.1562 67.7344 44.0234 69.0703 44.3047 71.4453C44.8438 75.8672 46.6484 76.9844 47.7969 77.0781C48.2344 81.2031 50.9531 86.0859 52.4219 86.8516C52.4219 89.7969 52.5312 92.0469 52.2344 95.2734C48.7344 104.695 25.0938 102.047 24 120.219H100C98.9062 102.047 75.3672 104.695 71.8672 95.2734Z",
    fill: "#9F9EA1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5635_11628"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaleBanned);
export default __webpack_public_path__ + "static/media/male-banned.2aae0f2b055083eb904133b3e5f6abbf.svg";
export { ForwardRef as ReactComponent };